import { FC, useState } from 'react';
import { Box, Button, Grid } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@hooks/redux-custom';
import { useGetOrderStatusesQuery } from '@services';
import { CustomerSearch } from '../Customers/CustomerSearch/CustomerSearch';
import CustomerInviteModal from './CustomerInviteModal/CustomerInviteModal';
import { useGetCustomerAttributesQuery } from '@services';
import { setCustomerAttributes } from '@store/slices/customer';
import { setOrderStatus } from '@store/slices/order';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const CustomersPage: FC = () => {
  const [openCustomerInviteModal, setOpenCustomerInviteModal] = useState(false);
  const dispatch = useAppDispatch();
  const activeUser = useAppSelector((state) => state.activeUser.value);
  const userAccessStatus = activeUser?.user?.roles.find((role: any) => role.moduleName === 'customer');
  const hasWriteAccess = userAccessStatus.role > 1;
  const { data } = useGetCustomerAttributesQuery();
  const { data: allOrderStatus } = useGetOrderStatusesQuery();

  if (allOrderStatus?.length) {
    dispatch(setOrderStatus(allOrderStatus));
  }

  if (data?.length) {
    dispatch(setCustomerAttributes(data));
  }

  return (
    <>
      <Grid container spacing={2} pt={2}>
        <Grid xs={12} item>
          <Box display="flex" justifyContent="flex">
            {hasWriteAccess && (
              <Button
                variant="contained"
                data-testid="invite-customer-btn"
                onClick={() => setOpenCustomerInviteModal(true)}
                endIcon={<PersonAddIcon />}
              >
                Invite Customer
              </Button>
            )}
            <CustomerInviteModal isOpen={openCustomerInviteModal} onClose={() => setOpenCustomerInviteModal(false)} />
          </Box>
        </Grid>
        <Grid xs={12} item>
          <CustomerSearch data-testid="customer-search" />
        </Grid>
      </Grid>
    </>
  );
};

export default CustomersPage;
